import { Sparkles, Compass, HandHeart } from "lucide-react";

const NELSON_IMG =
  "https://customer-assets.emergentagent.com/job_mortgage-broker-au-1/artifacts/69hamavm_IMG_7841.jpeg";

const PILLARS = [
  {
    icon: Compass,
    title: "Strategy first",
    desc: "Loan structures designed around your 5-, 10- and 20-year plans — not just today's rate.",
  },
  {
    icon: Sparkles,
    title: "Plain English",
    desc: "No banker speak. Everything explained so you make decisions with confidence.",
  },
  {
    icon: HandHeart,
    title: "Long-term partner",
    desc: "Annual rate reviews, refinance opportunities and life-stage planning — for years to come.",
  },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 max-w-7xl mx-auto px-6 lg:px-8"
    >
      <div className="grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative">
            <div className="absolute -bottom-6 -right-6 left-12 top-12 rounded-3xl bg-brand-sandDeep -z-0" />
            <img
              src={NELSON_IMG}
              alt="Nelson — Founder & Mortgage Broker, Empower Legacy Finance"
              className="relative rounded-3xl w-full h-[520px] object-cover object-top border border-border shadow-md"
            />
            <div className="absolute -bottom-6 -right-2 sm:-right-6 bg-brand-cream rounded-2xl border border-border shadow-lg px-5 py-4 max-w-[260px]">
              <div className="text-xs uppercase tracking-widest text-brand-ink/50">
                Your broker
              </div>
              <div className="font-display text-xl text-brand-ink mt-1">
                Nelson Saini
              </div>
              <div className="text-xs text-brand-ink/60 mt-0.5">
                Founder · Empower Legacy Finance
              </div>
            </div>
          </div>
        </div>
        <div className="lg:col-span-6 lg:col-start-7 order-1 lg:order-2">
          <div className="label-eyebrow text-brand-eucalyptus mb-5">
            Meet your broker
          </div>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight font-medium text-brand-ink">
            Honest advice, sharp negotiation, a broker who stays in your corner.
          </h2>
          <p className="mt-6 text-base md:text-lg text-brand-ink/70 leading-relaxed">
            I&apos;m Nelson Saini — founder of Empower Legacy Finance. I started this
            business because too many Australians get sold a product, not a
            strategy. My promise is simple: clear advice, sharp negotiation,
            and a broker who&apos;s still in your corner years after settlement.
          </p>

          <div className="mt-10 grid sm:grid-cols-3 gap-5">
            {PILLARS.map((p) => (
              <div
                key={p.title}
                data-testid={`about-pillar-${p.title.replace(/\s+/g, "-").toLowerCase()}`}
                className="rounded-2xl border border-border bg-card p-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-sm"
              >
                <p.icon className="h-5 w-5 text-brand-eucalyptus" strokeWidth={1.6} />
                <h3 className="mt-4 font-display text-lg text-brand-ink">{p.title}</h3>
                <p className="mt-2 text-sm text-brand-ink/65 leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
